import { EventInfo } from './event-info';
var Event = /** @class */ (function () {
    function Event(eventName, eventAction, type, attribute) {
        this.eventInfo = new EventInfo(eventName, eventAction, type);
        this.attribute = attribute;
    }
    Event.prototype.getEventInfo = function () {
        return this.eventInfo;
    };
    Event.prototype.getAttribute = function () {
        return this.attribute;
    };
    return Event;
}());
export { Event };
